import { useEffect, useSyncExternalStore } from 'react';
import { useAppSelector } from '@/app/hooks';
import api from '@/services/api';
import { ApiResponse, OnlineOrderSummary } from '@/services/types';
import { API_ENDPOINTS } from '@/utils/constants';
import { onPush } from '@/features/notifications/push';

/** Shared new/ready/sent counts for the nav badge, dashboard and orders page. Best-effort. */
let summary: OnlineOrderSummary | null = null;
let loadedForShop: number | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const subscribe = (cb: () => void) => { listeners.add(cb); return () => { listeners.delete(cb); }; };

export async function refreshOnlineOrderSummary(shopId: number) {
    try {
        const res = await api.get<ApiResponse<OnlineOrderSummary>>(API_ENDPOINTS.ONLINE_ORDERS_SUMMARY(shopId));
        loadedForShop = shopId;
        summary = res.data.data;
        emit();
    } catch { /* badge is best-effort */ }
}

export function useOnlineOrderSummary(): OnlineOrderSummary | null {
    const shopId = useAppSelector((s) => s.auth.selectedShop?.shopId);
    useEffect(() => {
        if (!shopId) return;
        if (loadedForShop !== shopId) refreshOnlineOrderSummary(shopId);
        return onPush(() => refreshOnlineOrderSummary(shopId));
    }, [shopId]);
    return useSyncExternalStore(subscribe, () => summary, () => null);
}
